module.exports = "<site-header></site-header>\n<router-outlet></router-outlet>\n<site-footer></site-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/site-layout/site-layout.component.html
// module id = ./src/app/site-layout/site-layout.component.html
// module chunks = main